import { render, staticRenderFns } from "./GridMobile.html?vue&type=template&id=ff923626&scoped=true&"
import script from "./GridMobile.js?vue&type=script&lang=js&"
export * from "./GridMobile.js?vue&type=script&lang=js&"
import style0 from "./GridMobile.scss?vue&type=style&index=0&id=ff923626&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ff923626",
  null
  
)

export default component.exports